import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { grid, griditem } from '../../motion-varients/grid';
import { projectsdata } from './projectsdata';
import TagButton from './TagButton/TagButton';

const StyledProjects = styled.div`
margin: auto;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`;

const StyledHeader = styled.div`
    width: 100%;
    padding: .5em;
    &>h1 {
        font-family: kenoky;
        font-size: 3rem;
        font-weight: 100;
    }
    &>div {
        height: 1px;
        background-color: black;
        width: 60%;
        margin: 1em 0 2em 0;
    }
`;

const StyledTags = styled.div`
    display: flex;
    justify-content: left;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 0 2em 0;
`;
const StyledButton = styled.button`
    border-radius: 20px;
    padding: .3em .7em;
    color: white;
    background-color: #282828;
    transition: all .2s;
    &:hover {
        scale: 1.05;
    }

`;

const StyledGrid = styled(motion.div)`
    padding: 1em;
    display: grid;
    grid-template: "a b" auto
                   "c d" auto;
    gap: 5em;
    align-items: center;
    @media (max-width: 1200px) {
        grid-template: "a" auto
                "b" auto
                "c" auto
                "d" auto;
        padding: 2em;
    } 
    &>* {
        &>* {
            display: flex;
            justify-content: center;
            align-items: left;
            flex-direction: column;
                &>img {
                    align-self: center;
                    margin-bottom: .5rem;
                }
                &>p:nth-of-type(1) {
                    font-size: 1.3rem;
                }
                &>p:nth-of-type(2) {
                    color: #626262;
                }
            }
    }
`;

const StyledImg = styled.img`
    width: 100%;
    height: auto;
    max-width: 40vw;
    border-radius: 4px;
    filter: brightness(.92);
    opacity: 0.88;
    transition: all 0.3s;
    transform: perspective(1500px) rotateY(-7deg);
    @media (max-width: 1200px) {
        max-width: 700px;
    } 
    
    &:hover {
        filter:none;
        opacity: 1;
        transform: perspective(3000px) rotateY(-5deg);
        
    }

`;


export default function Projects() {

    const [myTags, setMyTags] = useState([
        "React",
        "JavaScript",
        "Firebase",
        "Web App",
        "Object Oriented",
        "Website",
        "Game",
        "C++"
    ]
    );




    return (
        <StyledProjects>
            <StyledHeader>
                <h1>A few projects of mine.</h1>
                <div />
            </StyledHeader>
            <StyledTags>
                <StyledButton onClick={
                    //This could be made more efficient and reliable.   
                    () => {
                        console.log(myTags);
                        if (myTags.length >= 8) {
                            setMyTags([]);
                            return;
                        }
                        setMyTags(
                            [
                                "React",
                                "JavaScript",
                                "Firebase",
                                "Web App",
                                "Object Oriented",
                                "Website",
                                "Game",
                                "C++"
                            ]
                        );
                    }}>Select All</StyledButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>React</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>JavaScript</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>C++</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>Game</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>Website</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>Web App</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>Firebase</TagButton>
                <TagButton myTags={myTags} setMyTags={setMyTags}>Object Oriented</TagButton>
            </StyledTags>


            <StyledGrid
                variants={grid}
                initial="hidden"
                animate="show"
            >

                {
                    projectsdata && projectsdata.map((proj) => {
                        for (let i = 0; i < proj.tags.length; i++) {
                            for (let j = 0; j < myTags.length; j++) {
                                if (proj.tags[i] === myTags[j]) {
                                    return (
                                        <Link to={proj.link} key={proj.title}>
                                            <motion.div
                                                variants={griditem}
                                            >
                                                <StyledImg src={proj.pic} alt={proj.shortdesc} />
                                                <p>{proj.title}</p>
                                                <p>{proj.shortdesc}</p>
                                            </motion.div>
                                        </Link>
                                    );

                                }
                            }
                        }
                        return null;
                    })
                }

            </StyledGrid>

        </StyledProjects >
    )
}
